import script from "./DropdownItem.vue?vue&type=script&lang=ts&setup=true"
export * from "./DropdownItem.vue?vue&type=script&lang=ts&setup=true"

import "./DropdownItem.vue?vue&type=style&index=0&id=3a786a98&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3a786a98"]])

export default __exports__